// src/pages/user-pages/InvoicesManagement.js
import { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import "../InvoicesManagement.scss";
import { useNavigate } from "react-router-dom";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PinkPantherLoader from "../../components/PinkPantherLoader";
import CustomCheckbox from "../../components/CustomCheckbox";
// import ChartModal from "../../components/ChartModal";
import CustomInput from "../../components/CustomInput";
import Dropdown from "../../components/Dropdown";
import classes3 from "../../components/PDFUploader.module.css";
import { useDocs } from "../../utils/useDocs";
import { toMoney } from "../../utils/toMoney";
import { useTranslation } from "react-i18next";
import useLanguage from "../../utils/useLanguage";
import CustomButton from "../../components/CustomButton";
import containersIcon from "../../assets/container.png";
import CustomLink from "../../components/CustomLink";
import { getCleanedInvoiceNumber } from "../../utils/getCleanedInvoiceNumber";
import InformationBox from "../../components/InformationBox";
import Modal from "../../components/Modal";
import classes from "../../components/Modal.module.css";


import UserSection from "../../components/UserSection";
import { DataContext } from "../../utils/DataContext";
import PDFUploader from "../../components/PDFUploader";
import { sanitizeNumber } from "../../utils/sanitizeNumber";
import BackToDashboard from "../../components/BackToDashboard";
import Loader from "../../components/Loader";
import { UserAuth } from "../../utils/AuthContext";
import HotDropdown from "../../components/HotDropdown";
import { onlyNums } from "../../utils/OnlyNums";
import usePrint from "../../utils/hooks/usePrint";
import AreYouSureModal from "../../components/AreYouSureModal";
import { shouldCloseModal } from "../../utils/shouldCloseModal";
import LoaderWithProgress from "../../components/LoaderWithProgress";
import AllDocumentsSlider from "../../components/AllDocumentsSlider";

import { useReactToPrint } from "react-to-print";
import InvoicePrintComponent from "./InvoicePrint"; // Adjust path as needed
import { resolveIcon } from "../../utils/resolveIcon";
const InvoicesManagement = () => {
  const rows = [
    {
      title: "invoiceNumber",
      value: "invoiceNumber",
    },
    {
      title: "amount",
      value: "amount",
    },
    {
      title: "currency",
      value: "amountCurrency",
    },
    {
      title: "bankName",
      value: "bankName",
    },
    {
      title: "amountIn",
      value: "amountInSupCur",
    },
    {
      title: "Date",
      value: "date",
    },
    {
      title: "notes",
      value: "notes",
    },
  ];

  const [newRow, setNewRow] = useState({
    invoiceNumber: "",
    amount: "",
    amountCurrency: "USD",
    currencyRate: "",
    amountInSupCur: "",
    bankName: "",
    balance: 0,
    date: new Date(),
    notes: "",
    swift: "",
  });
  const [showBtns, setShowBtns] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [showAreYouSure, setShowAreYouSure] = useState(false);

  const [documents, setDocuments] = useState([]);

  const show3Buttons = () => {
    setShowBtns(true);
  };
  const navigate = useNavigate();

  const handleDeleteFile = (index) => {
    setTempDocs((prev) => {
      const newDocs = [...prev];
      newDocs.splice(index, 1); // Remove the file at the given index
      return newDocs;
    });

    // resetting the input element to empty
    const fileInput = document.getElementById(`invoiceDoc${index + 1}`);
    if (fileInput) {
      fileInput.value = "";
    }

    setPdfFile(null);
    setIsAnalyzable(false);
  };
  const [extractedData, setExtractedData] = useState({});

  const [docsFields, setDocsFields] = useState({
    count: 1,
    max: 10,
  });
  const [analyzeLoading, setAnalyzeLoading] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const { handlePrepareDocs } = useDocs();
  const [tempDocs, setTempDocs] = useState([]);
  const [isAnalyzable, setIsAnalyzable] = useState(false);

  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();

  const [selectedCurrency, setSelectedCurrency] = useState({
    title: "USD",
    id: "USD",
  });

  const [showInputFields, setShowInputFields] = useState(false);
  const [showAddInvoiceButton, setShowAddInvoiceButton] = useState(true);

  const [newRecord, setNewRecord] = useState({
    amount: "",
    amountCurrency: "USD",
    amountInSupCur: "",
    balance: 0,
    bankName: "",
    currencyRate: "",
    date: new Date(),
    invoiceNumber: "",
    notes: "",
    swift: "",
  });

  const [invoiceDocs, setInvoiceDocs] = useState([]);
  const pdfUploaderRef = useRef(null);

  const [selectAll, setSelectAll] = useState(false);
  const [chartModalOpen, setChartModalOpen] = useState(false);

  const [tempCurrentBalance, setTempCurrentBalance] = useState({
    value: 0,
    containerId: 0,
  });

  const [dublicatedNumberError, setDublicatedNumberError] = useState("");

  const {
    suppliers,
    getSuppliers,

    selectedSupplier,
    error,
    setError,
    loading,
    data,
    setData,
    currentBalance,
    setCurrentBalance,
    handleSelectSupplier,
    setSupplierFields,
    invoicesCurrentPage,
    setInvoicesCurrentPage,
    invoicesTotalPages,
    invoicesTotalRecords,
    setInviocesTotalRecords,
    fetchInvoices,
    fetchArchivedInvoices,
    handleSearch,
    selectedDate,
    setSelectedDate,
    selectedInvoicesStatus,
    setSelectedInvoicesStatus,
    searchQuery,
    setSearchQuery,
    selectedTitle,
    setSelectedTitle,
    currencies,
    setNetworkError,
    searchError,
    searchErrorMessage,
  } = useContext(DataContext);

  const { userData } = useContext(UserAuth);

  const balanceStyle =
    currentBalance?.value >= 0 ? "positive-value" : "negative-value";

  useEffect(() => {
    fetchInvoices();
  }, []);

  const handleChildUploadDocs = (invoiceId) => {
    // Implement the logic to call the child's handleUploadDocs function
    if (pdfUploaderRef.current) {
      pdfUploaderRef.current.handleUploadDocs(invoiceId);
    }
  };

  const handleShowChart = () => {
    setChartModalOpen(true);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    // Update the selected status for all rows in the data array
    setData((prevData) => {
      return prevData.map((row) => {
        return { ...row, selected: !selectAll };
      });
    });
  };

  const generateUploadInputs = () => {
    return Array.from({ length: docsFields.count }).map((_, index) => (
      <>
        <form className="o-column" key={index}>
          <div className="o-row o-row--vertical-align_center o-row--gap-size_400">
            <input
              accept="application/pdf, image/*"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                setPdfFile(file);
                handlePrepareDocs(
                  e,
                  // `Invoice ${invoiceNumber} - image ${index + 1}`
                  `image ${index + 1}`
                );
                setTempDocs((prev) => [...prev, file]);

                // Enable the Analyze button
                setIsAnalyzable(true);
              }}
              className={classes3.fileInput}
              name="images"
              id={`invoiceDoc${index + 1}`}
              disabled={tempDocs.length > 0}
            />
            <div>
              <label htmlFor={`invoiceDoc${index + 1}`}>
                <p
                  // className={classes3.customFileInput}
                  className={`${
                    tempDocs.length > 0 ? classes3.buttonDisabled : ""
                  } ${classes3.customFileInput}`}
                >
                  <img src={resolveIcon("upload")} alt={`Upload image ${index + 1}`} />
                  <span>
                    {t("uploadDocument")} {index + 1}
                  </span>
                </p>
              </label>
            </div>

            <CustomButton
              title={t("analyzeInvoice")}
              icon='analyze'
              variant="blank"
              onClick={handleUpload}
              type="submit"
              disabled={!isAnalyzable}
            />

            <CustomButton
              title={t("cancel")}
              variant="blank"
              icon='close'
              iconSize={14}
              onClick={() => {
                setShowBtns(false);
                handleDeleteFile(index);
              }}
            />
          </div>
          {analyzeLoading && (
            <PinkPantherLoader fullHeight={true} size="MEDIUM" />
          )}
          {tempDocs[index] && (
            <div className={classes3.fileName}>
              {t("fileName")} : {tempDocs[index]?.name?.slice(0, 30)}
              <button
                className={classes3.deleteFileButton}
                onClick={() => handleDeleteFile(index)}
              >
                <img src={resolveIcon("deleteCircled")} alt="delete icon" />
              </button>
            </div>
          )}
        </form>
      </>
    ));
  };

  const handleUpload = async (event) => {
    if (event) event.preventDefault();

    if (!pdfFile) {
      console.error("No file selected!");
      return;
    }

    const formData = new FormData();
    formData.append("image", pdfFile);

    try {
      setAnalyzeLoading(true);
      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_URL}/extractPdf`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
            "User-Id": userData?.userId,
            "Supplier-Id": selectedSupplier?.id,
          },
        }
      );

      if (uploadResponse.status === 200) {
        setExtractedData(uploadResponse.data);
        navigate("/analyzedNoCustomerInvoice", {
          state: { extractedData: uploadResponse.data }, // Pass correct data
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setAnalyzeLoading(false);
    }
  };

  const handleInputChange = (e, modal) => {
    const { name, value } = e.target;
    setError("");

    if (modal === "supplier") {
      setSupplierFields((prev) => ({ ...prev, [name]: value }));
    } else {
      setNewRecord((prevRec) => {
        let updatedRecord = { ...prevRec, [name]: value };

        if (name === "amountInSupCur") {
          if (value) {
            setTempCurrentBalance((prev) => ({
              ...prev,
              value: currentBalance?.value + parseFloat(sanitizeNumber(value)),
            }));
          } else {
            setTempCurrentBalance((prev) => ({
              ...prev,
              value: currentBalance.value,
            }));
          }
        }

        return updatedRecord;
      });

      // ! Old code
      setNewRow((prevRow) => {
        let updatedRow = { ...prevRow, [name]: value };

        if (name === "amountInSupCur") {
          if (value) {
            setTempCurrentBalance((prev) => ({
              ...prev,
              value: currentBalance.value + parseFloat(value),
            }));
          } else {
            setTempCurrentBalance((prev) => ({
              ...prev,
              value: currentBalance.value,
            }));
          }
        }

        return updatedRow;
      });
    }
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setNewRow((prevRow) => ({ ...prevRow, date: new Date(date) }));
    setNewRecord((prevRecord) => ({ ...prevRecord, date: new Date(date) }));
  };

  const isInvoiceNumberUnique = (invoiceNumber) => {
    return !data.some((row) => row.invoiceNumber === invoiceNumber);
  };

  const handleAddRow = async () => {
    if (!selectedSupplier?.id) {
      setError("emptyInputField");
      return;
    }

    if (!newRow?.invoiceNumber?.trim()) {
      setError(t("emptyInputField"));
      return;
    }

    if (!newRow?.amount?.trim()) {
      setError(t("emptyInputField"));
      return;
    }

    if (!newRow?.amountInSupCur?.trim()) {
      setError(t("emptyInputField"));
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const userId = parseInt(localStorage.getItem("userId"), 10);

      if (!userId) {
        console.error("User ID not found in localStorage");
        return;
      }

      setLoadingModal(true);
      const newInvoice = await axios.post(
        `${process.env.REACT_APP_URL}/createInvoice`,
        {
          ...newRow,
          amount: sanitizeNumber(newRow?.amount),
          amountInSupCur: sanitizeNumber(newRow?.amountInSupCur),
          balanceAfterUpdate:
            currentBalance?.value +
            parseFloat(sanitizeNumber(newRow.amountInSupCur)),
          balanceBeforeUpdate: currentBalance.value,
          userId,
          supplierId: selectedSupplier?.id,
          amountCurrency: selectedCurrency?.title,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "User-Id": userId,
          },
        }
      );

      // ! IMPORANTT
      // fetchData(selectedSupplier?.id);
      const newInvoiceId = newInvoice?.data?.id;
      const uploadDocuments = handleChildUploadDocs(newInvoiceId);

      setNewRecord({
        invoiceNumber: "",
        companyName: "",
        customerName: "",
        containerNumber: "",
        amount: "",
        amountCurrency: "USD",
        bankName: "",
        received: "",
        left: "",
        swift: "",
        date: new Date(),
        notes: "",
      });
      setNewRow({
        invoiceNumber: "",
        companyName: "",
        customerName: "",
        containerNumber: "",
        amount: "",
        amountCurrency: "USD",
        bankName: "",
        received: "",
        left: "",
        swift: "",
        date: new Date(),
        notes: "",
      });
      setError("");
      setDublicatedNumberError("");
      setShowInputFields(false);
      setCurrentBalance(tempCurrentBalance);
      setData((prev) => [newInvoice.data, ...prev]);
      setInviocesTotalRecords((prev) => prev + 1);
    } catch (error) {
      const errorMsg = error?.response?.data?.message;
      // * Should contain noivce not invoice because the i != I
      if (errorMsg?.includes("nvoice")) {
        setDublicatedNumberError(errorMsg);
      }

      console.error("Error adding new invoice:", error);
      setError("addInvoiceFailed");
      setNetworkError(true);
    } finally {
      setLoadingModal(false);
    }
  };

  const handleShowInputFields = () => {
    setShowInputFields(true);
  };

  const handleAttemptCancel = () => {
    setShowAreYouSure(true);
  };

  const handleCancel = () => {
    setShowInputFields(false);
    setError("");
    setInvoiceDocs([]);
    setDublicatedNumberError("");
    setNewRecord({
      invoiceNumber: "",
      companyName: "",
      customerName: "",
      amount: "",
      amountCurrency: "USD",
      bankName: "",
      received: "",
      left: "",
      swift: "",
      date: new Date(),
      notes: "",
    });
    setNewRow({
      invoiceNumber: "",
      companyName: "",
      customerName: "",
      amount: "",
      amountCurrency: "USD",
      bankName: "",
      received: "",
      left: "",
      swift: "",
      date: new Date(),
      notes: "",
    });
    setShowAreYouSure(false);
  };

  console.log("showAreYouSure", showAreYouSure);

  const [saerchByDate, setSaerchByDate] = useState(false);
  const handleSearchType = (type) => {
    setSelectedTitle(type);
    setSaerchByDate(false);
    if (type.value === "date") {
      setSaerchByDate(true);
    }
  };

  const printComponentRef = useRef();
  const printRef = useRef(null);

  const { handlePrintRows } = usePrint();

  const handlePrintInvoices = useReactToPrint({
    contentRef: printComponentRef,
    documentTitle: `Multiple-Invoices-${
      new Date().toISOString().split("T")[0]
    }`,
    pageStyle: `
      @page {
        size: 210mm 297mm;
      }
    `,
    onAfterPrint: () => {
      console.log("Invoices printed successfully");
    },
  });

  const handlePrint = () => {
    const selectedRows = data.filter((row) => row.selected);

    if (selectedRows.length) {
      setError("");
      handlePrintInvoices();
    } else {
      setError("noInvoiceToPrint");
    }
  };

  // const handlePrint = () => {
  //   const selectedRows = data.filter((row) => row.selected);

  //   if (selectedRows.length) {
  //     setError("");
  //     handlePrintRows(
  //       rows,
  //       data.filter((row) => row.selected)
  //     );
  //   } else {
  //     setError("noInvoiceToPrint");
  //   }
  // };

  // const handlePrint = () => {
  //   const selectedRows = data.filter((row) => row.selected);
  //   console.log("Selected Row: ", selectedRows);
  //   if (selectedRows.length) {
  //     setError("");
  //     sessionStorage.setItem("selectedRows", JSON.stringify(selectedRows));
  //     window.open("/print", "_blank");
  //   } else {
  //     setError("noInvoiceToPrint");
  //   }
  // };

  const handleChangeStatus = (status) => {
    const { value } = status;
    setSelectedInvoicesStatus(status);
    setInvoicesCurrentPage(1);
    setSearchQuery("");

    if (value === "active") {
      setShowAddInvoiceButton(true);
      fetchInvoices();
    } else if (value === "archived") {
      setShowAddInvoiceButton(false);
      fetchArchivedInvoices(selectedSupplier?.id);
    }
  };

  return (
    <>
      <main className="e-container">
        <div>
          <BackToDashboard
            title={t("back")}
            variant="blank"
            icon={currentDirection === "ltr" ? "previous" : "next"}
            iconSize={14}
            to={
              userData?.userType === "user"
                ? "/invoiceManagement"
                : `/${userData?.organizationType?.toLowerCase()}-dashboard`
            }
          />
        </div>

        <div className="invoice-table-container">
          <UserSection handleShowChart={handleShowChart} />

          <div className="under-user-section">
            <div className="page-title">{t("invoicesPage")}</div>
            <CustomButton
              elementType={Link}
              title={t("containers")}
              to="/containerPrices"
              icon='container'
              iconSize="30"
            />
          </div>

          {loading ? (
            <Loader />
          ) : (
            <>
              {error === "noInvoiceToPrint" ? (
                <div className="error-message">{t("noInvoiceToPrint")}</div>
              ) : null}

              {!selectedSupplier?.id ? (
                <div className="full-w-button-container">
                  <div className="column-flex-box flex-center-center">
                    <InformationBox>{t("noSuppliersAddOne")}</InformationBox>
                    <CustomButton
                      title={t("goToSuppliersPage")}
                      minWidth={140}
                      variant="blank"
                      elementType={Link}
                      to={"/viewSuppliersPage"}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="top-action-buttons responsive-box">
                    <div className="button-group">
                      {showAddInvoiceButton ? (
                        <CustomButton
                          title={t("createInvoice")}
                          onClick={handleShowInputFields}
                          icon='add'
                          iconSize={20}
                        />
                      ) : null}
                      {!showBtns && (
                        <CustomButton
                          title={t("analyzeInvoice")}
                          icon='analyze'
                          variant="blank"
                          onClick={show3Buttons}
                          iconSize={18}
                        />
                      )}

                      {data.length !== 0 ? (
                        <CustomButton
                          title={t("print")}
                          onClick={handlePrint}
                          variant="gray"
                          icon='print'
                          iconSize={18}
                        />
                      ) : null}
                    </div>

                    <section className="col title-col ">
                      <label>{t("invoicesStatus")}: </label>
                      <Dropdown
                        options={[
                          { title: "Active", value: "active" },
                          { title: "Archived", value: "archived" },
                        ]}
                        selected={selectedInvoicesStatus}
                        setSelected={handleChangeStatus}
                        thick
                      />
                    </section>
                  </div>
                  {showBtns && (
                    <div className="o-row o-row--gap-size_200">
                      <section className="u-margin--top_500 u-margin--bottom_500 full-width">
                        <div className={classes.pdfUploaderSection}>
                          <span>{t("uploadDocs")}: </span>
                          <div className={classes.pdfUploaderSectionActions}>
                            {generateUploadInputs()}
                          </div>
                        </div>
                      </section>

                      {documents.length ? (
                        <AllDocumentsSlider
                          documents={documents}
                          title="All Documents"
                        />
                      ) : null}
                    </div>
                  )}
                  {data.length !== 0 ? (
                    <>
                      <div className="c-search-bar u-margin--bottom_500">
                        <section className="c-search-bar-label-input">
                          <label>{t("search")}: </label>

                          {saerchByDate ? (
                            <DatePicker
                              selected={selectedDate}
                              onChange={(date) => {
                                setSelectedDate(
                                  date.toLocaleDateString("en-CA")
                                );
                              }}
                              dateFormat="yyyy-MM-dd"
                              placeholderText={t("searchByDate")}
                            />
                          ) : (
                            <CustomInput
                              placeholder={t("search")}
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                              resetSearch={() => {
                                setSearchQuery("");
                                handleSearch("");
                              }}
                              thick
                            />
                          )}
                        </section>

                        <section className="c-search-bar-label-input">
                          <label>{t("searchTitle")}: </label>
                          <Dropdown
                            options={rows.map((row) => ({
                              ...row,
                              title:
                                row.title === "amountIn"
                                  ? t("amountInSupplierCurrency")
                                  : row.title,
                            }))}
                            selected={selectedTitle}
                            setSelected={handleSearchType}
                            thick
                          />
                        </section>

                        <CustomButton
                          title={t("search")}
                          onClick={handleSearch}
                          icon='search'
                          iconSize={15}
                        />
                      </div>

                      <section className="table-container" ref={printRef}>
                        <table className="i-table">
                          <thead className="table-head">
                            <tr>
                              <th className="bold-text">
                                {/* Select or deselect all */}
                                <CustomCheckbox
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                  color="primary"
                                />
                              </th>

                              {rows.map((row, index) => {
                                if (row.title === "amountIn") {
                                  return (
                                    <th
                                      key={index}
                                      className={`bold-text cell-title ${
                                        row.value
                                      } ${
                                        row.value !== "invoiceNumber"
                                          ? "mobile-hider"
                                          : ""
                                      }`}
                                    >
                                      {t(row.title) +
                                        " " +
                                        selectedSupplier?.currency}
                                    </th>
                                  );
                                } else {
                                  return (
                                    <th
                                      key={index}
                                      className={`bold-text cell-title ${
                                        row.value
                                      } ${
                                        row.value !== "invoiceNumber"
                                          ? "mobile-hider"
                                          : ""
                                      }`}
                                    >
                                      {t(row.title)}
                                    </th>
                                  );
                                }
                              })}
                            </tr>
                          </thead>

                          <tbody className="table-body">
                            {/* These are the existing rows */}
                            {data?.map(
                              (row, index) =>
                                !row.canceled && (
                                  <tr key={index}>
                                    <td
                                      className={`cell ${
                                        currentDirection === "ltr"
                                          ? "rounded-first-cell"
                                          : "rounded-last-cell"
                                      }`}
                                    >
                                      <CustomCheckbox
                                        checked={row.selected || false}
                                        onChange={(e) => {
                                          const updatedRow = [...data];
                                          updatedRow[index].selected =
                                            e.target.checked;
                                          setData(updatedRow);
                                          console.log("row.selected: ", row);
                                        }}
                                      />
                                    </td>

                                    <td className="cell invoice-number">
                                      {row.archived ? (
                                        <span>
                                          <p className="archived-invoice">
                                            {getCleanedInvoiceNumber(
                                              row?.invoiceNumber
                                            )}
                                          </p>
                                          {row?.updateCounter > 0 &&
                                            !row?.archived && (
                                              <p className="update-note">
                                                {t("invoiceHasBeenUpdated")}
                                              </p>
                                            )}
                                        </span>
                                      ) : (
                                        <CustomLink to={`/invoice/${row?.id}`}>
                                          <p className="link">
                                            {getCleanedInvoiceNumber(
                                              row?.invoiceNumber
                                            )}
                                          </p>
                                          {row?.updateCounter > 0 &&
                                            !row?.archived && (
                                              <p className="update-note">
                                                {t("invoiceHasBeenUpdated")}
                                              </p>
                                            )}
                                        </CustomLink>
                                      )}
                                    </td>

                                    <td className="cell mobile-hider">
                                      {toMoney(row.amount)}
                                    </td>

                                    <td className="cell mobile-hider">
                                      {row.amountCurrency}
                                    </td>

                                    <td className="cell mobile-hider">
                                      {row.bankName}
                                    </td>

                                    <td className="cell mobile-hider">
                                      {toMoney(row.amountInSupCur)}
                                    </td>

                                    <td className="cell mobile-hider">
                                      {row.date
                                        ? new Date(row.date)
                                            ?.toISOString()
                                            .split("T")[0]
                                        : ""}
                                    </td>
                                    <td
                                      className={`cell notes-cell mobile-hider ${
                                        currentDirection === "ltr"
                                          ? "rounded-last-cell"
                                          : "rounded-first-cell"
                                      }`}
                                    >
                                      {row.notes}
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </table>
                      </section>
                      <section className="pagination">
                        <div className="pagination-buttons">
                          <CustomButton
                            variant="blank"
                            title={t("previous")}
                            onClick={() =>
                              setInvoicesCurrentPage(invoicesCurrentPage - 1)
                            }
                            disabled={invoicesCurrentPage === 1}
                            icon={
                              currentDirection === "ltr"
                                ? 'previous'
                                : 'next'
                            }
                            iconSize={15}
                          />
                          <span className="pagination-location">
                            {t("page")}: {invoicesCurrentPage} -{" "}
                            {invoicesTotalPages}
                          </span>
                          <CustomButton
                            title={t("next")}
                            variant="blank"
                            onClick={() =>
                              setInvoicesCurrentPage(invoicesCurrentPage + 1)
                            }
                            disabled={
                              invoicesCurrentPage === invoicesTotalPages
                            }
                            icon={
                              currentDirection === "ltr"
                                ? "next"
                                : "previous"
                            }
                            iconSize={15}
                            reverseIcon
                          />
                        </div>

                        <div className="pagination-buttons">
                          <span className="pagination-location">
                            {t("totalRecords")}: {invoicesTotalRecords}
                          </span>
                        </div>
                      </section>
                      {selectedSupplier?.id !== "All" && (
                        <p className="current-balance">
                          <span>{t("currentBalance")}: </span>
                          <span className={balanceStyle}>
                            {toMoney(currentBalance?.value)}{" "}
                            {selectedSupplier?.currency}
                          </span>
                        </p>
                      )}
                    </>
                  ) : (
                    <InformationBox>
                      {searchError ? t(searchErrorMessage) : t("noInvoices")}
                    </InformationBox>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </main>

      {showInputFields && (
        <Modal
          title="createInvoice"
          onClose={handleAttemptCancel}
          footer={
            <>
              {loadingModal ? <Loader /> : null}
              <section className={classes.actions}>
                <CustomButton
                  onClick={handleAddRow}
                  title={t("confirm")}
                  icon='save'
                  iconSize={16}
                  disabled={loadingModal}
                />
                <CustomButton
                  title={t("cancel")}
                  onClick={handleAttemptCancel}
                  variant="blank"
                  icon='close'
                  iconSize={14}
                />
              </section>
            </>
          }
        >
          <div className={classes.flexableForm}>
            <section>
              <div className={classes.inputContainer}>
                <span>{t("supplier")}: </span>
                <HotDropdown
                  initOptions={suppliers}
                  selected={selectedSupplier}
                  setSelected={handleSelectSupplier}
                  thick
                  flex
                  getData={getSuppliers}
                  optionsName={"suppliers"}
                  errorText={error}
                />
              </div>
            </section>
            <section className={`${classes.section} ${classes.invoiceNumber}`}>
              <div className={classes.inputContainer}>
                <span>{t("invoiceNumber")}: </span>
                <div className={classes.invoiceNumberContainer}>
                  {dublicatedNumberError && (
                    <div className="error-message">
                      {t("dublicatedInvoiceNumber")}
                    </div>
                  )}
                  <CustomInput
                    name="invoiceNumber"
                    value={getCleanedInvoiceNumber(
                      newRecord?.invoiceNumber || ""
                    )}
                    onChange={handleInputChange}
                    flex={true}
                    errorText={
                      error
                        ? error
                        : dublicatedNumberError
                        ? dublicatedNumberError
                        : null
                    }
                  />
                </div>
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("Date")}: </span>
                <CustomInput
                  name="date"
                  type="date"
                  flex={true}
                  value={
                    newRecord?.date
                      ? newRecord.date.toISOString().split("T")[0]
                      : ""
                  }
                  onChange={(date) => handleDateChange(date)}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("amount")}: </span>
                <CustomInput
                  name="amount"
                  value={newRecord?.amount || ""}
                  onChange={handleInputChange}
                  onKeyDown={(e) => onlyNums(e)}
                  type="money"
                  flex={true}
                  errorText={error}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("currency")}: </span>
                <Dropdown
                  options={currencies}
                  selected={selectedCurrency}
                  setSelected={setSelectedCurrency}
                  thick
                  flex
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("bankName")}: </span>
                <CustomInput
                  name="bankName"
                  value={newRecord?.bankName || ""}
                  onChange={handleInputChange}
                  flex={true}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("amountIn") + selectedSupplier?.currency}: </span>
                <CustomInput
                  name="amountInSupCur"
                  value={newRecord?.amountInSupCur || ""}
                  onChange={handleInputChange}
                  onKeyDown={(e) => onlyNums(e)}
                  type="money"
                  flex={true}
                  errorText={error}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("currencyRate")}: </span>
                <CustomInput
                  name="currencyRate"
                  value={newRecord?.currencyRate || ""}
                  onChange={handleInputChange}
                  onKeyDown={(e) => onlyNums(e)}
                  type="money"
                  flex={true}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span>{t("SWIFT")}: </span>
                <CustomInput
                  name="swift"
                  value={newRecord?.swift || ""}
                  onChange={handleInputChange}
                  flex={true}
                />
              </div>
            </section>
            <section className={classes.section}>
              <div className={classes.inputContainer}>
                <span className={`${classes.notesSpan}`}>{t("notes")}: </span>
                <CustomInput
                  name="notes"
                  type="textarea"
                  value={newRecord?.notes || ""}
                  onChange={handleInputChange}
                  flex={true}
                />
              </div>
            </section>
            <PDFUploader
              ref={pdfUploaderRef}
              invoiceNumber={data?.invoiceNumber}
              invoiceDocs={invoiceDocs}
              setInvoiceDocs={setInvoiceDocs}
              mode="upload"
              documents={data?.documents}
              tempDocs={invoiceDocs}
              setTempDocs={setInvoiceDocs}
            />
          </div>
        </Modal>
      )}
      {showAreYouSure ? (
        <AreYouSureModal
          shouldCloseModal={shouldCloseModal({
            ...newRecord,
            // Skip the currency
            amountCurrency: "",
            invoiceDocs: invoiceDocs?.length,
          })}
          onClose={() => setShowAreYouSure(false)}
          onConfirm={handleCancel}
          confirmIconType="whiteCheck"

        />
      ) : null}

      {/* Hidden Print Components */}
      <div
        ref={printComponentRef}
        style={{ backgroundColor: "#fff", margin: "0", padding: "0" }}
      >
        {data
          .filter((row) => row.selected)
          .map((invoice, index) => (
            <div
              key={invoice.id}
              style={{
                pageBreakAfter:
                  index < data.filter((row) => row.selected).length - 1
                    ? "always"
                    : "auto",
                pageBreakInside: "avoid",
                paddingTop: index === 0 ? "" : "10px",
              }}
            >
              <InvoicePrintComponent
                invoiceData={invoice}
                supplierData={{
                  id: invoice.supplierId,
                  name: invoice.Supplier?.name,
                  currency: selectedSupplier?.currency || "USD",
                }}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default InvoicesManagement;
